import { PermissionCheckerService } from "abp-ng2-module";
import { Injector, ElementRef, Component, OnInit, ViewEncapsulation, Renderer2, AfterViewInit, ChangeDetectorRef, OnDestroy } from "@angular/core";
import { AppComponentBase } from "@shared/common/app-component-base";
import { AppMenu } from "./app-menu";
import { AppNavigationService } from "./app-navigation.service";
import { ActivatedRoute, NavigationEnd, Router } from "@angular/router";
import { filter } from "rxjs/operators";
import { MenuOptions } from "@metronic/app/core/_base/layout/directives/menu.directive";
import { FormattedStringValueExtracter } from "@shared/helpers/FormattedStringValueExtracter";
import * as objectPath from "object-path";
import {
    CommonCacheServiceProxy, ProjectListViewSummaryDto, TimesheetServiceProxy
} from "../../../../shared/service-proxies/service-proxies";
import { AppConsts } from "@shared/AppConsts";
import { AppMenuItem } from "./app-menu-item";
import * as _ from "lodash";
import { Subscription, firstValueFrom } from 'rxjs';
import { NewQuickStartService } from "../../../main/Service/new-quick-start.service";
import { AppRoutes } from "@app/shared/routes/app-routes";

@Component({
    standalone: false,
    templateUrl: "./side-bar-menu.component.html",
    selector: "side-bar-menu",
    encapsulation: ViewEncapsulation.None,
    providers: [NewQuickStartService]
})
export class SideBarMenuComponent extends AppComponentBase implements OnInit, AfterViewInit, OnDestroy {
    menu: AppMenu = null;

    currentRouteUrl = "";
    insideTm: any;
    outsideTm: any;
    rootMenus: string[] = [];
    isLoginForFirstTime  : boolean = false;
    subscription: Subscription;
    checkLogin: boolean = false;
    collapsedSubmenuName = "";
    hoveredSubmenuName = "";
    private collapsedFlyoutLeaveTimer: ReturnType<typeof setTimeout> | null = null;
    private routerEventsSubscription: Subscription;
    private readonly checkLoginSuccessForSideBarHandler = () => this.checkLoginSuccessForSideBar();
    private readonly sideBarToggleHandler = (data) => this.isSideBarToggle(data);
    menuOptions: MenuOptions = {
        submenu: {
            desktop: {
                default: "dropdown",
            },
            tablet: "accordion",
            mobile: "accordion",
        },

        accordion: {
            expandAll: false,
        },
    };

    constructor(
        injector: Injector,
        private el: ElementRef,
        private _router: Router,
        private _route: ActivatedRoute,
        public permission: PermissionCheckerService,
        private _appNavigationService: AppNavigationService,
        private render: Renderer2,
        private _tsProxy: TimesheetServiceProxy,
        private _commonCacheServiceProxy: CommonCacheServiceProxy,
        private cdRef: ChangeDetectorRef,
    ) {
        super(injector);
    }

    ngOnInit() {
        this.checkLoginSuccessForSideBar();
        this.getUserWiseOtherSetting();
        abp.event.on('checkLoginSuccessForSideBar', this.checkLoginSuccessForSideBarHandler);
        abp.event.on('isSideBarToggle', this.sideBarToggleHandler);
        this.checkLogin = JSON.parse(localStorage.getItem('checkLoginSuccess'));

        if (this.checkLogin) {
            abp.event.trigger('checkLoginSuccessFordefault');
            abp.event.trigger('checkLoginForTopbardownload');
            abp.event.trigger('checkLoginForTopbarSetting');
        }

    }
    //
    // Get User Wise setting and Hide Perticular Menu
    //

    async checkLoginSuccessForSideBar() {
        this.checkLogin = JSON.parse(localStorage.getItem('checkLoginSuccess'));
    }

    async getUserWiseOtherSetting() {
        // this._userServiceProxy.getUserTrackOtherSettingForEdit(this._abpSessionService.tenantId, this._abpSessionService.userId).subscribe(x => {
        //     this.menu = this._appNavigationService.getMenu();
        //     if (x.isProjectSec)
        //         this.hideMainMenuFromLeftSection('Projects');
        //     if (x.isHideSS)
        //         this.hideChildMenuFromLeftSection('Screenshots');
        //     this.findAllRootMenus(this.menu.items);
        //     this.currentRouteUrl = this._router.url.split(/[?#]/)[0];
        //     this._router.events
        //         .pipe(filter((event) => event instanceof NavigationEnd))
        //         .subscribe(
        //             (event) =>
        //                 (this.currentRouteUrl = this._router.url.split(/[?#]/)[0])
        //         );
        // });
        let x;
        if (!AppConsts.userSettings && abp.session.tenantId) {
            x = await firstValueFrom(this._commonCacheServiceProxy.getUserTrackOtherSettingForEdit(abp.session.tenantId, abp.session.userId));
            AppConsts.userSettings = x;
        } else {
            x = AppConsts.userSettings;
        }
        this.currentRouteUrl = this._router.url.split(/[?#]/)[0];
        this.menu = this._appNavigationService.getMenu();

        const a = this.menu.items.find(x => x.name == 'Activities').items.find(a => a.name == 'RealTimeTracking').name;

        this.injectMenuForClient();       
        if (x !== undefined) {
            if (x.isProjectSec) this.hideMainMenuFromLeftSection("Projects");
            if (x.isHideSS) this.hideChildMenuFromLeftSection("Screenshots");
        }       
        this.findAllRootMenus(this.menu.items);
        this.routerEventsSubscription = this._router.events
            .pipe(filter((event) => event instanceof NavigationEnd))
            .subscribe((event) => {
                this.currentRouteUrl = this._router.url.split(/[?#]/)[0];
                this.collapsedSubmenuName = "";
                this.hoveredSubmenuName = "";
            });
    }

    async injectMenuForClient(): Promise<void> {
        const userRoleClient = AppConsts.userRoleArray.includes('client');
        if (!userRoleClient) return;
        const projectListForSumarry = await firstValueFrom(this._tsProxy.getProjectListForViewSummary([], []));
        const projectList = await firstValueFrom(this._tsProxy.getProjectListForClient([], []));
        projectList.forEach(x => {
           
        })
        this.menu.items.push(new AppMenuItem("Dashboard", null, "icon-dash", AppRoutes.clientsDashboard))
        for (let i = 0; i < projectList.length; i++) {
            this.menu.items.push(this.createProjectMenuItem(projectList[i], projectListForSumarry.some(x => x.projectId === projectList[i].projectId)));
           
        }
        this.menu.items.push(new AppMenuItem("Reports", "", "icon-invoice", AppRoutes.reports))

    }

    createProjectMenuItem(project: ProjectListViewSummaryDto, isClientApprover: boolean): AppMenuItem {
        let submenues = isClientApprover ? [
           
            new AppMenuItem("Team", null, "icon-Team", AppRoutes.clientsPortalTeam, undefined, undefined, undefined, { projectId: project.projectId }),
            new AppMenuItem("Task", null, "icon-Task", AppRoutes.clientsPortalTask, undefined, undefined, undefined, { projectId: project.projectId }),
            new AppMenuItem("Timesheet View", null, "icon-TimeSheet", AppRoutes.clientsPortalTimesheet, undefined, undefined, undefined, { projectId: project.projectId }),
            new AppMenuItem("Work Schedule", null, "icon-Workschedule", AppRoutes.clientsPortalWorkSchedule, undefined, undefined, undefined, { projectId: project.projectId }),
            new AppMenuItem("Timesheet Summary", null, "icon-TimeSheetSummary", AppRoutes.timesheet, undefined, undefined, undefined, { projectId: project.projectId }),
            new AppMenuItem("Invoices", null, "icon-Invoices", AppRoutes.clientsPortalInvoices, undefined, undefined, undefined, { projectId: project.projectId }),
            new AppMenuItem("Consult Us", null, "icon-ConsultUs", AppRoutes.clientsPortalConsult, undefined, undefined, undefined, { projectId: project.projectId }),
        ] :
        [
                new AppMenuItem("Team", null, "icon-Team", AppRoutes.clientsPortalTeam, undefined, undefined, undefined, { projectId: project.projectId }),
                new AppMenuItem("Task", null, "icon-Task", AppRoutes.clientsPortalTask, undefined, undefined, undefined, { projectId: project.projectId }),
                new AppMenuItem("Timesheet View", null, "icon-TimeSheet", AppRoutes.clientsPortalTimesheet, undefined, undefined, undefined, { projectId: project.projectId }),
                new AppMenuItem("Work Schedule", null, "icon-Workschedule", AppRoutes.clientsPortalWorkSchedule, undefined, undefined, undefined, { projectId: project.projectId }),
                new AppMenuItem("Invoices", null, "icon-Invoices", AppRoutes.clientsPortalInvoices, undefined, undefined, undefined, { projectId: project.projectId }),
                new AppMenuItem("Consult Us", null, "icon-ConsultUs", AppRoutes.clientsPortalConsult, undefined, undefined, undefined, { projectId: project.projectId }),
        ];
        return new AppMenuItem(
            _.capitalize(project.projectName),
            null,
            null,
            "",
            [],
            submenues,
            undefined,
            undefined,
            undefined,
            undefined,
            project.projectImage ? project.projectImage : "assets/common/images/new-dashboard/default-project-bag.svg"
        );
    }

    ngAfterViewInit(): void {
        this.scrollToCurrentMenuElement();
        this.ui.setSubmenuToggle(false);
        this.cdRef.detectChanges();
    }

    showMenuItem(menuItem): boolean {
        return this._appNavigationService.showMenuItem(menuItem);
    }

    isMenuItemIsActive(item): boolean {
        if (item.items.length) {
            return this.isMenuRootItemIsActive(item);
        }

        if (!item.route) {
            return false;
        }

        if (this.currentRouteUrl.includes("app-category") || this.currentRouteUrl.includes("services")) {
            return false;
        }

        const urlTree = this._router.parseUrl(this.currentRouteUrl.replace(/\/$/, ''));
        const urlString = '/' + urlTree.root.children.primary.segments.map(segment => segment.path).join('/');
        const menuItemURL = item.route.replace(/\/$/, '');

        if (item.routeTemplates?.length) {
            for (let i = 0; i < item.routeTemplates.length; i++) {
                const result = new FormattedStringValueExtracter().Extract(urlString, item.routeTemplates[i]);
                if (result.IsMatch) {
                    return true;
                }
            }
        }

        const isRouteMatch = urlString === menuItemURL || urlString.startsWith(menuItemURL + '/');
        if (!isRouteMatch) {
            return false;
        }

        return this.matchesMenuItemProjectIdFilter(menuItemURL, item);
    }

    private matchesMenuItemProjectIdFilter(menuItemURL: string, item: AppMenuItem): boolean {
        const projectIdParam = this._route.snapshot.queryParams["projectId"];
        const itemProjectId = (item.parameters as { projectId?: number } | undefined)?.projectId;
        if (!projectIdParam || typeof itemProjectId !== 'number') {
            return true;
        }

        const projectId = parseInt(projectIdParam, 10);

        const projectScopedRoutes: string[] = [
            AppRoutes.timesheet,
            AppRoutes.clientsPortalTeam,
            AppRoutes.clientsPortalTask,
            AppRoutes.clientsPortalWorkSchedule,
            AppRoutes.clientsPortalInvoices,
            AppRoutes.clientsPortalConsult,
            AppRoutes.clientsPortalTimesheet,
        ];

        if (projectScopedRoutes.includes(menuItemURL)) {
            return projectId === itemProjectId;
        }

        return true;
    }

    isMenuRootItemIsActive(item): boolean {
        let result = false;
        for (const subItem of item.items) {
            result = this.isMenuItemIsActive(subItem);
            if (result) {
                return true;
            }
        }
        return false;
    }

    findAllRootMenus(itemCollection) {
        let result = false;
        for (let subItem of itemCollection) {
            if (subItem.items.length) {
                let menuItemURL = subItem.items[0].route.replace(/\/$/, "");
                let menuSubUrl = menuItemURL.substring(0, menuItemURL.lastIndexOf("/"));
                this.rootMenus.push(menuSubUrl);
                this.findAllRootMenus(subItem.items);
            }
        }
    }

    /**
     * Use for fixed left aside menu, to show menu on mouseenter event.
     * @param e Event
     */
    mouseEnter(e: Event) {
        const isAppSideNav = this.el.nativeElement.closest('#kt_aside')?.classList.contains('app-side-nav');

        if (isAppSideNav) {
            this.render.removeClass(document.body, "aside-minimize-hover");
            if (localStorage.getItem('aside-minimize-isSet') === 'true') {
                this.render.addClass(document.body, "aside-minimize");
            }
            return;
        }

        // check if the left aside menu is fixed
        if (document.body.classList.contains("aside-fixed")) {
            if (this.outsideTm) {
                clearTimeout(this.outsideTm);
                this.outsideTm = null;
            }

            this.insideTm = setTimeout(() => {
                // if the left aside menu is minimized
                if (
                    document.body.classList.contains("aside-minimize") &&
                    KTUtil.isInResponsiveRange("desktop") &&
                    document.body.classList.contains("aside-minimize-hoverable")
                ) {
                    // show the left aside menu
                    this.render.removeClass(document.body, "aside-minimize");
                    this.render.addClass(document.body, "aside-minimize-hover");
                }
            }, 50);
        }
        if (document.body.classList.contains("aside-minimize") &&
            !document.body.classList.contains("aside-menu-dropdown")
        ) {
            // show the left aside menu
            this.render.addClass(e.target, "aside-menu-dropdown");
        }
    }

    /**
     * Use for fixed left aside menu, to show menu on mouseenter event.
     * @param e Event
     */
    mouseLeave(e: Event) {
        const isAppSideNav = this.el.nativeElement.closest('#kt_aside')?.classList.contains('app-side-nav');

        if (isAppSideNav) {
            this.render.removeClass(document.body, "aside-minimize-hover");
            if (localStorage.getItem('aside-minimize-isSet') === 'true') {
                this.render.addClass(document.body, "aside-minimize");
            }
            return;
        }

        if (document.body.classList.contains("aside-fixed")) {
            if (this.insideTm) {
                clearTimeout(this.insideTm);
                this.insideTm = null;
            }

            this.outsideTm = setTimeout(() => {
                // if the left aside menu is expand
                if (document.body.classList.contains("aside-minimize-hover") && KTUtil.isInResponsiveRange("desktop")) {
                    // hide back the left aside menu
                    this.render.removeClass(document.body, "aside-minimize-hover");
                    this.render.addClass(document.body, "aside-minimize");
                }
            }, 100);
        }
        this.render.removeClass(e.target, "aside-menu-dropdown");
    }

    scrollToCurrentMenuElement(): void {
        const path = location.pathname;
        const menuItem = document.querySelector("a[href='" + path + "']");
        if (menuItem) {
            menuItem.scrollIntoView({ block: "center" });
        }
    }

    getItemAttrSubmenuToggle(item) {
        let toggle = "hover";
        if (!document.body.classList.contains("aside-minimize")) {
            toggle = "click";
        } else if (this.el.nativeElement.closest('#kt_aside')?.classList.contains('app-side-nav')) {
            toggle = "click";
        } else if (objectPath.get(item, "submenu.type") === "tabs") {
            toggle = "tabs";
        } else {
            // submenu toggle default to 'hover'
        }

        return toggle;
    }

    toggleCollapsedSubmenu(event: Event, item) {
        if (!this.isAsideCollapsed() || !item.items?.length) {
            return;
        }

        event.preventDefault();
        event.stopPropagation();
        this.collapsedSubmenuName = this.collapsedSubmenuName === item.name ? "" : item.name;
        this.hoveredSubmenuName = this.collapsedSubmenuName;
        this.cdRef.detectChanges();
        this.positionCollapsedFlyout((event.currentTarget as HTMLElement).closest(".menu-item") ?? undefined);
    }

    onSubmenuLinkClick(event: Event, item) {
        if (this.isAsideCollapsed()) {
            this.toggleCollapsedSubmenu(event, item);
        }
    }

    isAsideCollapsed(): boolean {
        return document.body.classList.contains("aside-minimize") &&
            !!this.el.nativeElement.closest("#kt_aside")?.classList.contains("app-side-nav");
    }

    isCollapsedSubmenuOpen(item): boolean {
        return this.isAsideCollapsed() &&
            !!item.items?.length &&
            (this.hoveredSubmenuName === item.name || this.collapsedSubmenuName === item.name);
    }

    onCollapsedMenuItemEnter(item, parentItem, event?: Event) {
        if (parentItem || !this.isAsideCollapsed() || !item.items?.length) {
            return;
        }

        this.clearCollapsedFlyoutLeaveTimer();
        this.hoveredSubmenuName = item.name;
        this.cdRef.detectChanges();
        this.positionCollapsedFlyout(event?.currentTarget as HTMLElement);
    }

    onCollapsedMenuItemLeave(event: Event, item, parentItem) {
        if (parentItem || !this.isAsideCollapsed() || !item.items?.length) {
            return;
        }

        const relatedTarget = (event as MouseEvent).relatedTarget as Node | null;
        const menuItem = event.currentTarget as HTMLElement;

        if (relatedTarget && menuItem.contains(relatedTarget)) {
            return;
        }

        this.scheduleCollapsedFlyoutClose(item.name);
    }

    onCollapsedSubmenuEnter(item, parentItem, event?: Event) {
        if (parentItem || !this.isAsideCollapsed()) {
            return;
        }

        this.clearCollapsedFlyoutLeaveTimer();
        this.hoveredSubmenuName = item.name;
        this.cdRef.detectChanges();
        this.positionCollapsedFlyout((event?.currentTarget as HTMLElement)?.closest(".menu-item") ?? undefined);
    }

    onCollapsedSubmenuLeave(event: Event, item, parentItem) {
        if (parentItem || !this.isAsideCollapsed()) {
            return;
        }

        const relatedTarget = (event as MouseEvent).relatedTarget as Node | null;
        const menuItem = (event.currentTarget as HTMLElement).closest(".menu-item");

        if (relatedTarget && menuItem?.contains(relatedTarget)) {
            return;
        }

        this.scheduleCollapsedFlyoutClose(item.name);
    }

    private clearCollapsedFlyoutLeaveTimer(): void {
        if (this.collapsedFlyoutLeaveTimer) {
            clearTimeout(this.collapsedFlyoutLeaveTimer);
            this.collapsedFlyoutLeaveTimer = null;
        }
    }

    private scheduleCollapsedFlyoutClose(itemName: string): void {
        this.clearCollapsedFlyoutLeaveTimer();
        this.collapsedFlyoutLeaveTimer = setTimeout(() => {
            if (this.hoveredSubmenuName === itemName) {
                this.hoveredSubmenuName = "";
            }

            if (this.collapsedSubmenuName === itemName) {
                this.collapsedSubmenuName = "";
            }

            this.cdRef.detectChanges();
        }, 150);
    }

    private positionCollapsedFlyout(menuItemEl?: HTMLElement): void {
        if (!menuItemEl || !this.isAsideCollapsed()) {
            return;
        }

        requestAnimationFrame(() => {
            const flyout = menuItemEl.querySelector(":scope > .menu-submenu.menu-submenu-flyout") as HTMLElement | null;
            if (!flyout) {
                return;
            }

            flyout.style.removeProperty("display");
            flyout.style.removeProperty("height");
            flyout.style.removeProperty("overflow");

            const anchor = (menuItemEl.querySelector(":scope > .menu-link") as HTMLElement) ?? menuItemEl;
            const rect = anchor.getBoundingClientRect();
            const collapsedWidth = parseInt(
                getComputedStyle(document.documentElement).getPropertyValue("--app-shell-aside-collapsed-width") || "56",
                10
            );

            flyout.style.position = "fixed";
            flyout.style.left = `${collapsedWidth + 8}px`;
            flyout.style.top = `${rect.top}px`;
            flyout.style.zIndex = "1060";

            const flyoutHeight = flyout.offsetHeight;
            const maxTop = window.innerHeight - flyoutHeight - 8;
            if (rect.top > maxTop) {
                flyout.style.top = `${Math.max(8, maxTop)}px`;
            }
        });
    }

    private clearCollapsedFlyoutStyles(): void {
        this.el.nativeElement.querySelectorAll(".menu-submenu").forEach((submenu: HTMLElement) => {
            submenu.style.removeProperty("top");
            submenu.style.removeProperty("left");
            submenu.style.removeProperty("position");
            submenu.style.removeProperty("z-index");
            submenu.style.removeProperty("width");
            submenu.style.removeProperty("min-width");
        });
    }

    private closeExpandedAccordionSubmenus(): void {
        const menuRoot = this.el.nativeElement.querySelector("#kt_aside_menu");
        if (!menuRoot) {
            return;
        }

        menuRoot.querySelectorAll(".menu-item").forEach((item: HTMLElement) => {
            item.classList.remove("menu-item-open", "menu-item-hover", "collapsed-submenu-open");
        });

        menuRoot.querySelectorAll(".menu-submenu").forEach((submenu: HTMLElement) => {
            submenu.removeAttribute("style");
            submenu.querySelectorAll(".menu-subnav").forEach((subnav: HTMLElement) => {
                subnav.removeAttribute("style");
            });
        });

        menuRoot.querySelectorAll(".menu-nav > .menu-item.menu-item-submenu").forEach((item: HTMLElement) => {
            const submenu = item.querySelector(":scope > .menu-submenu") as HTMLElement | null;
            if (submenu && typeof KTUtil !== "undefined") {
                KTUtil.css(submenu, "display", "none");
                KTUtil.css(submenu, "height", "0");
                KTUtil.css(submenu, "overflow", "hidden");
            }
        });

        const menuInstance = KTUtil.data(menuRoot).get("menu");
        menuInstance?.hideDropdowns?.();
    }

    isSideBarToggle(isCollapsed: boolean) {
        if (isCollapsed) {
            this.closeExpandedAccordionSubmenus();
        }

        this.ui.setSubmenuToggle(false);
        this.collapsedSubmenuName = "";
        this.hoveredSubmenuName = "";
        this.clearCollapsedFlyoutLeaveTimer();
        this.clearCollapsedFlyoutStyles();
        this.cdRef.detectChanges();

        requestAnimationFrame(() => {
            if (isCollapsed) {
                this.closeExpandedAccordionSubmenus();
                this.cdRef.detectChanges();
                return;
            }

            const menuElement = this.el.nativeElement.querySelector("#kt_aside_menu");
            const menuInstance = menuElement ? KTUtil.data(menuElement).get("menu") : null;
            menuInstance?.reload();
            this.cdRef.detectChanges();
        });
    }

    getItemCssClasses(item) {
        let classes = "menu-item";

        if (objectPath.get(item, "submenu")) {
            classes += " menu-item-submenu";
        }

        if (!item.items && this.isMenuItemIsActive(item)) {
            classes += " menu-item-active menu-item-here";
        }

        if (item.items && this.isMenuItemIsActive(item)) {
            classes += " menu-item-here";
            if (!document.body.classList.contains("aside-minimize")) {
                classes += " menu-item-open";
            }
        }

        if (item.items?.length && document.body.classList.contains("aside-minimize") && this.isCollapsedSubmenuOpen(item)) {
            classes += " menu-item-open collapsed-submenu-open";
        }

        // custom class for menu item
        const customClass = objectPath.get(item, "custom-class");
        if (customClass) {
            classes += " " + customClass;
        }

        if (objectPath.get(item, "icon-only")) {
            classes += " menu-item-icon-only";
        }

        return classes;
    }

    //
    // Hide Tab From Main Menus
    //
    hideMainMenuFromLeftSection(MenuName: string) {
        this.menu.items.forEach((item, index) => {
            if (item.name === MenuName) this.menu.items.splice(index, 1);
        });
    }
    //
    // Hide Tab From SubMenus
    //
    hideChildMenuFromLeftSection(SubMenuName: string) {
        this.menu.items.forEach((item, index) => {
            item.items.forEach((subitem, subidx) => {
                if (subitem.name === SubMenuName) this.menu.items[index].items.splice(subidx, 1);
            });
        });
    }

    ngOnDestroy() {
        this.routerEventsSubscription?.unsubscribe();
        this.clearCollapsedFlyoutLeaveTimer();
        abp.event.off('checkLoginSuccessForSideBar', this.checkLoginSuccessForSideBarHandler);
        abp.event.off('isSideBarToggle', this.sideBarToggleHandler);
    }
}
